// error keys (used to display error message to user via locale files)

// Data error
export const REQUIRED = 'error.required';
export const INVALID_DATE = 'error.date.invalid';
export const DATE_TOO_EARLY = 'error.date.min';
export const DATE_TOO_LATE = 'error.date.max';
export const INVALID_EMAIL = 'error.email.pattern';
export const NOT_EQUAL = 'NOT_EQUAL';
export const EXCLUSION = 'EXCLUSION';
export const INCLUSION = 'error.inclusion';
export const INVALID_FORMAT = 'INVALID_FORMAT';
export const INVALID_LENGTH = 'INVALID_LENGTH';
export const LENGTH_WRONG = 'LENGTH_WRONG';
export const LENGTH_TOO_LONG = 'LENGTH_TOO_LONG';
export const LENGTH_TOO_SHORT = 'error.minimumLength';
export const INVALID_NUMBER = 'error.invalidNumber';
export const NUMBER_NOT_INTEGER = 'NUMBER_NOT_INTEGER';
export const NUMBER_NOT_GREATER_THAN = 'NUMBER_NOT_GREATER_THAN';
export const NUMBER_NOT_GREATER_THAN_OR_EQUAL_TO = 'NUMBER_NOT_GREATER_THAN_OR_EQUAL_TO';
export const NUMBER_NOT_EQUAL_TO = 'NUMBER_NOT_EQUAL_TO';
export const NUMBER_NOT_LESS_THAN = 'NUMBER_NOT_LESS_THAN';
export const NUMBER_NOT_LESS_THAN_OR_EQUAL_TO = 'NUMBER_NOT_LESS_THAN_OR_EQUAL_TO';
export const NUMBER_NOT_DIVISIBLE_BY = 'NUMBER_NOT_DIVISIBLE_BY';
export const NUMBER_NOT_ODD = 'NUMBER_NOT_ODD';
export const NUMBER_NOT_EVEN = 'NUMBER_NOT_EVEN';
export const INVALID_URL = 'INVALID_URL';
export const INVALID_COUNTRY = 'error.location.toggleablelocation.country.notfound';
export const DATE_IN_THE_PAST = 'error.date.past';
export const END_DATE_TOO_EARLY = 'error.date.endDateTooEarly';
export const RELINQUISHED_DATE_TOO_EARLY = 'error.date.relinquishedDateTooEarly';
export const LAST_CONTACT_DATE_TOO_EARLY = 'error.date.lastContactDateTooEarly';
export const SOLD_DATE_TOO_EARLY = 'error.date.soldDateTooEarly';
export const NOT_WITHIN_LAST_SEVEN_YEARS = 'error.date.notWithinSevenYears';
export const OLDEST_SELECTED_BIRTHDATE = 'error.date.oldestSelectedBirthdate';

// Custom validator errors
export const MISSING_ITEMS = 'MISSING_ITEMS';
export const INVALID_BRANCH = 'INVALID_BRANCH';
export const INVALID_ITEM = 'INVALID_ITEM';
export const INCOMPLETE_COLLECTION = 'INCOMPLETE_COLLECTION';
export const REQUIREMENT_NOT_MET = 'REQUIREMENT_NOT_MET';
export const INVALID_DATE_RANGE = 'error.daterange.invalid';
export const DATE_RANGE_TOO_SHORT = 'error.daterange.tooShort';
export const DATE_RANGE_TOO_LONG = 'error.daterange.tooLong';
export const INCOMPLETE_DURATION = 'INCOMPLETE_DURATION';
export const MISSING_VALUE = 'MISSING_VALUE';
export const VALUE_NOT_EMPTY = 'VALUE_NOT_EMPTY';
export const VALUE_NOT_TRUE = 'VALUE_NOT_TRUE';
export const INVALID_SSN = 'error.ssn.invalid';
export const ZIPCODE_STATE_MISMATCH = 'error.location.toggleablelocation.zipcode.status';
export const DUPLICATE_PHONE_NUMBER_TYPES = 'error.telephone.duplicate';
export const PRESENT_UNCHECKED = 'error.durationCoverage.presentUnchecked';

// Internal errors (i.e., options)
export const INVALID_VALIDATOR = 'INVALID_VALIDATOR';
export const INVALID_REQUIREMENTS = 'INVALID_REQUIREMENTS';
export const INVALID_DURATION = 'INVALID_DURATION';
